import { FC } from 'react'
import CameraAltIcon from '@mui/icons-material/CameraAlt'
import { SvgIconProps } from '@mui/material/SvgIcon'

export const CameraIcon: FC<SvgIconProps> = (props: SvgIconProps) => {
  return <CameraAltIcon {...props} />
}
